import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../Context/AppContext';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const NewsCarousel = (props: any) => {
  const { news, index, handleReadMore } = props;
  const { isMobile } = useContext(AppContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = news?.contents?.length || 0;
  const [hasNext, setHasNext] = useState(isMobile ? totalSlides > 1 : totalSlides > 3);
  const [hasPrev, setHasPrev] = useState(false);

  useEffect(() => {
    if (totalSlides === 0) {
      setCurrentIndex(0);
    }
    if ((isMobile && totalSlides <= 1) || (!isMobile && totalSlides <= 3)) {
      setCurrentIndex(totalSlides);
    }
    setHasNext(
      !isMobile && totalSlides === 4 && currentIndex === 2 ? false : currentIndex < totalSlides - 1,
    );
    setHasPrev(
      isMobile
        ? totalSlides <= 1
          ? false
          : currentIndex > 0
        : !isMobile && totalSlides <= 3
          ? false
          : currentIndex > 1,
    );
  }, [totalSlides, currentIndex, isMobile]);

  const handleNext = () => {
    if (hasNext) {
      setCurrentIndex((prevIndex) => {
        if (isMobile) {
          return prevIndex + 1;
        } else {
          let newIndex;
          if (prevIndex === totalSlides - 3 || prevIndex === 0) {
            newIndex = prevIndex + 2;
          } else {
            newIndex = prevIndex + 1;
          }
          return newIndex;
        }
      });
    }
  };

  const handlePrev = () => {
    if (hasPrev) {
      setCurrentIndex((prevIndex) => {
        if (isMobile) {
          return prevIndex - 1;
        } else {
          let newIndex;
          if (prevIndex === totalSlides - 1 || prevIndex === 2) {
            newIndex = prevIndex - 2;
          } else {
            newIndex = prevIndex - 1;
          }
          return newIndex;
        }
      });
    }
  };

  let startX: number | null = null;
  let startY: number | null = null;

  const handleSwipeStart = (event: React.TouchEvent<Element>) => {
    if (!event?.touches?.length) return;
    const touch = event?.touches[0];
    startX = touch?.clientX;
    startY = touch?.clientY;
  };

  const handleSwipeEnd = (event: React.TouchEvent<Element>) => {
    if (startX === null || startY === null || !event?.changedTouches?.length) return;
    const touch = event?.changedTouches[0];
    const endX = touch?.clientX;
    const endY = touch?.clientY;
    if (Math.abs(endY - startY) > Math.abs(endX - startX)) {
      document.getElementById('Home_Main_Section')?.scrollTo(0, (endY - startY) * -5);
    } else {
      if (startX > endX) {
        handleNext();
      } else if (startX < endX) {
        handlePrev();
      }
    }
    startX = null;
    startY = null;
  };

  return (
    <div key={news?.title + index} className="Home_News_Section">
      {isMobile && <p className="Home_News_Section_Title">{news?.title}</p>}
      <div className={`Home_News_Card_Container ${news?.value}`} id={`${news?.value}`}>
        {!news?.contents?.length ? (
          <div>No News available</div>
        ) : (
          <Carousel
            className="NewsCarousel"
            centerMode
            centerSlidePercentage={100 / (isMobile ? 1 : totalSlides < 3 ? totalSlides : 3)}
            selectedItem={currentIndex}
            axis={'horizontal'}
            animationHandler="slide"
            showStatus={false}
            showIndicators={false}
            showThumbs={false}
            swipeable={true}
            useKeyboardArrows={true}
            emulateTouch={true}
            onSwipeStart={handleSwipeStart}
            onSwipeEnd={handleSwipeEnd}
            renderArrowPrev={() => {
              return (
                <div
                  aria-disabled={!hasPrev}
                  className={`Carousel_Arrow prev ${!hasPrev ? 'disabled' : 'active'}`}
                  onClick={handlePrev}
                >
                  <img src="/oo/assets/icon/right-arrow.png" alt="logo" />
                </div>
              );
            }}
            renderArrowNext={() => {
              return (
                <div
                  aria-disabled={!hasNext}
                  className={`Carousel_Arrow next ${!hasNext ? 'disabled' : 'active'}`}
                  onClick={handleNext}
                >
                  <img src="/oo/assets/icon/right-arrow.png" alt="logo" />
                </div>
              );
            }}
          >
            {news?.contents?.length > 0 &&
              news?.contents?.map((content: any, index: number) => {
                return (
                  <div className="Home_News_Card" key={content?.title + index}>
                    <div className="Home_News_Card_Hero_Image">
                      <img src={content?.cover_image?.url} alt={content?.cover_image?.title} />
                    </div>
                    <p className="Home_News_Card_Title">{content?.title}</p>
                    <div className="Home_News_Card_Subtitle">
                      {content?.content?.length < 80 ? (
                        <p className='Home_News_Card_Subtitle_Content'>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: content?.content,
                            }}
                          />
                        </p>
                      ) : (
                        <div>
                          <p className='Home_News_Card_Subtitle_Content'>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: content?.content?.substring(0, 80)?.trim().replaceAll("<br />", " ") + '...',
                              }}
                            />
                          </p>
                          <div
                            className="ReadMore"
                            data-testid="ReadMore"
                            onClick={() => handleReadMore(content)}
                          >
                            Read More
                            <img
                              className="Right_Arrow"
                              src="/oo/assets/icon/right-arrow.png"
                              alt="logo"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </Carousel>
        )}
      </div>
    </div>
  );
};
export default NewsCarousel;
